import { pb } from '@/utils/pb'
import { UsersRecord } from '@/utils/types/pocketbase-types'

export const changePassword = async (values: {
  userId: string
  password: string
  oldPassword: string
  passwordConfirm: string
}) => {
  const res = pb.collection('users').update(values.userId, {
    oldPassword: values.oldPassword,
    password: values.password,
    passwordConfirm: values.passwordConfirm,
  })
  return res
}
export const changeUserSettings = async (values: Partial<UsersRecord>) => {
  if (pb.authStore?.record) {
    const user = await pb
      .collection('users')
      .update(pb.authStore.record.id, values)
    return user
  } else {
    throw new Error('User not authenticated')
  }
}

export const loginWithPassword = async ({
  email,
  password,
}: {
  email: string
  password: string
}) => {
  const authData = await pb
    .collection('users')
    .authWithPassword(email, password)
  return authData
}

export const getCurrentUser = async () => {
  if (pb.authStore?.record) {
    const user = await pb
      .collection('users')
      .getOne(pb.authStore?.record?.id as string)
    return user
  } else {
    return null
  }
}

export const heartBeat = async () => {
  await pb.send('/api/heartbeat', { method: 'POST' })
}

export const checkServerHealth = async () => {
  return await pb.send('/api/health', { method: 'GET' })
}
